const e = {
  name: "IsleOfMan",
  dimensions: { width: 25, height: 25 },
  content: `
    <g>
      <path d="M4.25977 4.08696L1.25977 2.08696L2.25977 8.08696L8.25977 5.08696V9.08696L11.2598 11.087L13.3598 9.08696L11.8598 2.58696C11.5598 1.28696 10.0598 0.68696 8.95977 1.38696L4.25977 4.08696Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20.2598 10.0869L23.2598 8.08691L19.2598 6.08691L17.2598 12.0869L13.2598 9.08691L11.2598 11.0869V14.0869L16.9598 16.1869C18.1598 16.5869 19.4598 15.8869 19.6598 14.5869L20.2598 10.0869Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5.95969 19.5869L4.25969 23.0869L9.25969 21.0869L6.25969 15.0869L11.2597 14.0869V11.0869L8.25969 9.08691L3.35969 12.8869C2.25969 13.4869 1.95969 14.9869 2.85969 15.8869L5.95969 19.5869Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  e as IsleOfMan
};
